import * as React from "react";

interface NavbarLink {
	path: string;
	text: string;
	prefetch?: string;
	style?: React.CSSProperties;
	externalLink?: boolean;
}

export const navbarLinks: NavbarLink[] = [
	{path: "", text: "Home"},
	// {path: "news", text: "News"},
	{path: "music", text: "Music"},
	{path: "idols", text: "Idols", prefetch: "intent"},
	{path: "timeline", text: "Our Journey", prefetch: "intent"},
	{path: "staff", text: "Staff", prefetch: "intent"},
	{path: "credits", text: "Credits"},
	{path: "https://ko-fi.com/dreamfloweridols/shop", text: "Shop", style: {color: "var(--logo_dark)"}, externalLink: true},
]